import { atom, selector, selectorFamily } from 'recoil';
import { PointFeature } from 'supercluster';
import { LiveStatus, LiveStatusDetail } from '../types/liveStatus';
import { persistedAtom } from '../utils/persistence';

export const liveStatusState = persistedAtom<LiveStatus[] | undefined>('app.client.liveStatus', undefined);

export const liveStatusSelectState = selectorFamily<LiveStatus | undefined, string>({
  key: 'app.client.liveStatus.select',
  get:
    (id) =>
    ({ get }) => {
      const liveStatus = get(liveStatusState);
      if (!liveStatus) return;
      return liveStatus.find((status) => status.identifier === id);
    },
});

export const mapLiveStatusGeoJson = selector<PointFeature<{ cluster: boolean; label: string; point_count: number }>[]>({
  key: 'app.map.liveStatus.geojson',
  get: ({ get }) => {
    const pointsInView = get(liveStatusInViewState);
    if (!pointsInView) return [];

    return pointsInView.map((liveStatus) => {
      const feature: PointFeature<{ cluster: boolean; label: string; point_count: number }> = {
        type: 'Feature',
        properties: { cluster: false, label: liveStatus.label, point_count: 0 },
        geometry: liveStatus.point as GeoJSON.Point,
      };
      return feature;
    });
  },
});

export const liveStatusInViewState = atom<LiveStatusDetail[] | undefined>({
  key: 'app.map.liveStatus.visible',
  default: undefined,
});
